import styled from "styled-components";

export const DeleteInfoList = styled.div`
  display: grid;
  gap: 10px;
`;
